export default __webpack_public_path__ + "static/media/653.d89b77ec.gif";